import React from 'react';
import { MaintainAspectRatio } from '@frontend/web/components/MaintainAspectRatio';
import { css } from 'emotion';
import { textSans } from '@guardian/src-foundations/typography';
const titleStyle = css `
	p {
		${textSans.large()};
		font-weight: bold;
	}
`;
export const VineBlockComponent = ({ element }) => {
    return (React.createElement(React.Fragment, null, element.url && element.width && element.height && (React.createElement("div", null,
        React.createElement("div", { className: titleStyle },
            React.createElement("p", null, element.title)),
        React.createElement(MaintainAspectRatio, { height: element.height, width: element.width },
            React.createElement("div", { className: "element-vine" },
                React.createElement("iframe", { title: "vine-embed", src: element.url, height: element.height, width: element.width }),
                React.createElement("script", { async: true, src: "https://platform.vine.co/static/scripts/embed.js" })))))));
};
